import { Box, Grid } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormField from '../FormField';

interface HelloPageSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
}

export default function HelloPageSection({
  control,
  errors,
}: HelloPageSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      {/* <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        {t('createGuiVersionPage.helloPage')}
      </Typography> */}

      <Box display="flex" gap={2} width="100%">
        <Box flex="1">
          <FormField
            name="logoPath"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.logoPath')}
          />
        </Box>
        <Box flex="1">
          <FormField
            name="compobotName"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.compobotName')}
          />
        </Box>
      </Box>
    </Grid>
  );
}
